import React, { Component } from 'react';
//import Config from './Config';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/ProductHistory.css';
import FX from './functions/functions';



class ProductHistory extends Component {
  constructor(props) {
    super(props);
    this.state = { history:[] };
  }
  search = () => {
    var search_str;
    if(document.getElementById("search_text")){
      search_str = document.getElementById("search_text").value;
    }
    console.log(search_str);
  }
  componentDidUpdate(prevProps, prevState, snapshot){
    if(this.props.product_id != prevProps.product_id){
        var data = {customer_id: this.props.root.state.customer_id, product_id: this.props.product_id};
        var qs = FX.encodeQueryData(data, true);
        FX.load(this.props.root,'product_history' + qs , (res, i) => {
          console.log(res);
          this.setState({history:res});
        });
          
    }
  }

  componentWillMount(){
    console.log('Here I come');
    console.log(this.props.product_id);
    var data = {customer_id: this.props.root.state.customer_id, product_id: this.props.product_id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'product_history' + qs , (res, i) => {
      console.log(res);
      this.setState({history:res});
    });
  }
  componentWillUnmount(){
    console.log('Here I go');
    console.log(this.props.product_id)
  }
  showMenu = () => {
    this.props.root.setState({menu_show: !this.props.root.state.menu_show});
  }
  render() {
    var className;
    var hist = this.state.history.map (hist => {
      console.log(hist);
      
      var dateField = FX.dateFormat(hist.log_inventory.created ,'{d2}/{m2}/{Y}');
      
      if( hist.log_inventory.class_id == 2 ){
          return (<tr onClick={FX.navigate.bind(this.props.root, 'dispatches'  , undefined ,'/dispatches/' + hist.log_inventory.object_id)}><td  >{hist.log_inventory.stock_from}</td><td>{hist.log_inventory.stock_to}</td><td className="move_ref"><i className="fa fa-cube" aria-hidden="true" /> {hist.dispatcher.name}</td><td>{dateField}</td></tr>);
      }
      else if( hist.log_inventory.class_id == 1 ){
          return (<tr onClick={FX.navigate.bind(this.props.root, 'deliveries'  , undefined ,'/deliveries/' + hist.log_inventory.object_id)}><td  >{hist.log_inventory.stock_from}</td><td>{hist.log_inventory.stock_to}</td><td className="move_ref"><i className="fa fa-truck" aria-hidden="true" /> {hist.dispatcher.name}</td><td>{dateField}</td></tr>);
      }
      else {
          return (<tr><td>{hist.log_inventory.stock_from}</td><td>{hist.log_inventory.stock_to}</td><td className="move_ref"><i className="fa fa-user-circle-o" aria-hidden="true" /> {hist.dispatcher.name}</td><td>{dateField}</td></tr>);
      }
    })
    if(!hist.length){
      hist = <div className="empty">[None]</div>
    }
    return (
      <div className={className} id="ProductHistory">
        <div className="title">Product History</div>
        <div className="itemList">
        <table>
          {hist}
        </table>
        </div>
      </div>
    );
  }
}

export default ProductHistory;



// WEBPACK FOOTER //
// ./src/ProductHistory.js